<div class="modal-header">
  <h3 class="modal-title">Preishistorie</h3>
</div>

<div class="modal-body">

  <table class="table whitetable">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>Menge</th>
        <th>K.-Me</th>
        <th>Lose</th>
        <th>Freigabe</th>
        @if (isCn) {
          <th><i class="fa fa-truck"></i></th>
        }
        <th style="font-weight: bold;">Einzel {{ typFormat }}</th>
        @if (isCn) {
          <th>Einkaufspreis {{ typFormat }}</th>
        }
        @if (isCn) {
          <th>Preis %</th>
        }
        <th>Gesamt</th>
        @if (isCn) {
          <th>Wechselkurs</th>
        }
        <th>Kalk</th>
        <th>Benutzer</th>
        <th>Datum</th>
        <th>Notiz</th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      @for (obj of objects; track obj; let i = $index) {
        <tr>
          <td>
            @if (!obj.valid) {
              <i class="fa fa-exclamation-triangle" style="color: #a94442 !important;"></i>
            }
          </td>
          <td>{{ obj.quanity }}</td>
          <td>
            @if (obj.calc_quanity) {
              <span>{{ obj.calc_quanity }}</span>
            }
            @if (!obj.calc_quanity) {
              <span>{{ obj.quanity }}</span>
            }
          </td>
          <td>{{ obj.lose }}</td>
          <td>{{ obj.release }}</td>
          @if (isCn) {
            <td>{{ obj.producer }}</td>
          }
          <td style="font-weight: bold;">{{ obj.single }}</td>
          @if (isCn) {
            <td>{{ obj.cost }}</td>
          }
          @if (isCn) {
            <td>{{ obj.price_reduction }}</td>
          }
          <td>{{ obj.multi }}</td>
          @if (isCn) {
            <td>{{ obj.exchange }}</td>
          }
          <td>{{ obj.calc }}</td>
          <td>{{ obj.username }}</td>
          <td>{{ obj.date|date:"dd.MM.yyyy HH:mm:ss" }}</td>
          <td>{{ obj.notes }}</td>
          <td>
            @if ((i !== 0)) {
              <button type="button"
                class="btn btn-sm btn-default"
                (click)="reset(obj)"
                >
                Zurücksetzen
              </button>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>

</div>

<div class="modal-footer">
</div>
